document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-ruqy-success]');
  if (!modal) return;

  const card = modal.querySelector('[data-ruqy-success-card]');
  const closeButtons = modal.querySelectorAll('[data-ruqy-success-close]');
  const closeModal = () => {
    modal.hidden = true;
  };

  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  requestAnimationFrame(() => card?.focus());
});
